import React, { useEffect } from "react";
import { Outlet, Navigate, useNavigate } from "react-router-dom";

const PrivateRoutes = () => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("auth_token");
  useEffect(() => {
    const handleEvent = (event) => {
      if (event.key === "auth_token" && !event.newValue) {
        navigate("/login");
      }
    };
    window.addEventListener("storage", handleEvent);

    return () => {
      window.removeEventListener("storage", handleEvent);
    };
  }, [navigate]);

  return <>{isLoggedIn ? <Outlet /> : <Navigate to="/login" />}</>;
};

export default PrivateRoutes;